class BaseStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }
}

export default BaseStore;
